var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.447 5.67v.004l2.053 5.91V19.5c0 .274-.226.5-.5.5h-1a.503.503 0 0 1-.5-.5V18h-13v1.5c0 .274-.226.5-.5.5H4a.503.503 0 0 1-.5-.5v-7.916l2.052-5.908c.143-.4.511-.676.948-.676h11c.443 0 .814.28.947.67ZM6.85 6h-.356l-.116.336-1.04 3-.23.664H18.882l-.23-.664-1.04-3L17.495 6H6.85ZM19 17h.5v-5.239l-.024-.075-.11-.34-.112-.346H4.766l-.117.334-.12.34-.029.08V17H19ZM8.5 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "#282828",
    stroke: "#282828"
  })));
};
export default SvgCar;